<template>
    <div>
        <van-field @click="onToggleVisible" :value="value" :label="label" :placeholder="placeholder" readonly clickable/>
        <van-popup position="bottom" v-model="visible">
            <van-picker :title="placeholder" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onToggleVisible" />
        </van-popup>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            columns: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                visible: false
            }
        },
        methods: {
            onConfirm(value) {
                this.$emit('input', value);
                this.onToggleVisible()
            },
            onToggleVisible() {
                this.visible = !this.visible;
            }
        },
    }
</script>

<style lang="less" scoped>

</style>